"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleStatus = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const material_1 = require("@mui/material");
const theme_1 = __importDefault(require("../../../theme"));
const Circle_1 = __importDefault(require("@mui/icons-material/Circle"));
const Typo_1 = require("../Typo/Typo");
const styled_1 = __importDefault(require("@emotion/styled"));
const StyledBox = (0, styled_1.default)(material_1.Box) `
  display: flex;
  align-items: center;
  gap: 8px;
`;
const CircleStatus = ({ label, variant }) => {
    return ((0, jsx_runtime_1.jsxs)(StyledBox, { children: [(0, jsx_runtime_1.jsx)(Typo_1.Typo, Object.assign({ variant: "labelForStatus" }, { children: label })), (0, jsx_runtime_1.jsx)(material_1.Box, Object.assign({ sx: theme_1.default.circleStatus[`${variant}`] }, { children: (0, jsx_runtime_1.jsx)(Circle_1.default, { width: 20, height: 20 }) }))] }));
};
exports.CircleStatus = CircleStatus;
